<template>
  <div class="main-frame">
    <MXHeader class="header" :collapsed="collapsed" @toggleCollapse="collapsed = !collapsed" />
    <div class="body">
      <MXSidebar class="left" :collapsed="collapsed" @toggleCollapse="collapsed = !collapsed"></MXSidebar>
      <div class="right">
        <MXPageTabs v-if="isTabMenuVisible"></MXPageTabs>
        <div class="router-view-wrapper">
          <!-- <keep-alive> -->
            <router-view class="router-view-container"></router-view>
          <!-- </keep-alive> -->
        </div>
      </div>
    </div>
    <!-- <div class="footer">蜜雪冰城 © 2020</div> -->
  </div>
</template>
<script>
import MXHeader from '@/components/MXHeader'
import MXSidebar from '@/components/MXSidebar'
import MXPageTabs from '../components/MXPageTabs.vue'
export default {
  name: 'Dashboard',
  data() {
    return {
      collapsed: false,
    }
  },
  components: {
    MXSidebar,
    MXHeader,
    MXPageTabs,
  },
  created() {
    // this.getJDETemplates()
    // this.getProductCategory()
    // this.getStoreGroups()
  },
  computed: {
    isTabMenuVisible() {
      return this.$store.state.tabMenu
    },
  },
  methods: {
    getJDETemplates() {
      this.$axios.get(`/jde/materiel/options`).then(({ data }) => {
        this.$store.commit('setJDETemplates', data.data)
      })
    },
    getProductCategory() {
      this.$axios.get('/category/all').then(({ data }) => {
        this.$store.commit('setProductCategory', data.data)
      })
    },
    getStoreGroups() {
      this.$axios.get(`group/options`).then(({ data }) => {
        this.$store.commit('setStoreGroups', data.data)
      })
    },
  },
}
</script>
<style lang="stylus" scoped>
.main-frame
  display: flex
  flex-flow: column
  position: relative
  height: 100%
  background: #f5f5f5

  .header
    flex: 0 0 56px

  .body
    flex: auto
    display: flex
    width: 100%
    height: 0

    .left
      flex: 0 0 auto

    .right
      display: flex
      flex-flow: column
      width: 0
      flex: auto

  .footer
    flex: 0 0 50px
    line-height: 50px
    text-align: center
    background: #fff
    border-top: 1px solid #f5f5f5

.router-view-wrapper
  background: #EEEEEE
  padding: 14px
  display: flex
  flex-flow: column
  height: 0
  flex: auto

  .router-view-container
    display: flex
    flex-flow: column
    height: 0
    flex: auto
</style>
